var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKubautoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 520,
    viewBox: "0 0 1600 520",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "KubAuto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grayPrem",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6D7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BDC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldPrem",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E7CF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C9A25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A7435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sheen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFFFFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFFFFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premiumShadow",
    x: "-25%",
    y: "-45%",
    width: "160%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "off"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "off",
    stdDeviation: 14,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blur",
    type: "matrix",
    values: "0 0 0 0 0                 0 0 0 0 0                 0 0 0 0 0                 0 0 0 0.26 0",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadow"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "inner",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "b",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "innerShadow",
    type: "matrix",
    values: "0 0 0 0 0                 0 0 0 0 0                 0 0 0 0 0                 0 0 0 0.30 0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "over"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edgeHi",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFFFFF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,350)",
    filter: "url(#premiumShadow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Poppins, Montserrat, Arial, sans-serif",
    fontSize: 230,
    fontWeight: 900,
    letterSpacing: -10,
    fill: "url(#grayPrem)",
    filter: "url(#inner)"
  }, "\n            KubAuto\n        "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Poppins, Montserrat, Arial, sans-serif",
    fontSize: 230,
    fontWeight: 900,
    letterSpacing: -10,
    fill: "none",
    stroke: "url(#edgeHi)",
    strokeWidth: 4,
    opacity: 0.85
  }, "\n            KubAuto\n        "), /*#__PURE__*/React.createElement("path", {
    d: "M40 36 C300 90, 760 92, 1120 34",
    fill: "none",
    stroke: "url(#goldPrem)",
    strokeWidth: 10,
    strokeLinecap: "round",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 34 C380 76, 760 78, 1040 36",
    fill: "none",
    stroke: "url(#sheen)",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKubautoLogo);
export default __webpack_public_path__ + "static/media/kubauto-logo.ed813c19647217121d97c9c49beecf51.svg";
export { ForwardRef as ReactComponent };